import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  userInfo: null
}

const getters = {

}

const mutations = {

}

const actions = {

}

const modules = {

}

export default new Vuex.Store({
  getters,
  state,
  mutations,
  actions,
  modules
})
